import {NgModule} from '@angular/core';
import {PdfComponent} from './pages/pdf/pdf.component';
import {BudgetPreviewComponent} from './pages/budget-preview/budget-preview.component';
import {CommonModule, DecimalPipe, DatePipe} from '@angular/common';
import {NzCellAlignDirective, NzTableComponent} from 'ng-zorro-antd/table';
import {NzDescriptionsComponent, NzDescriptionsItemComponent} from 'ng-zorro-antd/descriptions';
import {NzCardComponent} from 'ng-zorro-antd/card';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzSpinComponent} from 'ng-zorro-antd/spin';
import {SharedModule} from "@app/shared";


@NgModule({
  declarations: [
    BudgetPreviewComponent
  ],
    imports: [
        CommonModule,
        PdfComponent, // Importar en lugar de declarar porque es standalone
        NzTableComponent,
        NzDescriptionsItemComponent,
        NzDescriptionsComponent,
        NzCardComponent,
        NzButtonComponent,
        NzSpinComponent,
        DecimalPipe,
        DatePipe,
        NzCellAlignDirective,
        NzColDirective,
        NzRowDirective,
        SharedModule
    ],
    exports: [
        PdfComponent,
        BudgetPreviewComponent
    ]
})
export class PdfModule {
}
